import React from 'react'
import { Helmet } from 'react-helmet'

const CustomHelmet = () => {
  return (
    <Helmet>
      <meta name='apple-itunes-app' content='app-id=1517880692, app-argument=https://apps.apple.com/us/app/edge-capacity/id1517880692' />
    </Helmet>

  )
}

export default CustomHelmet
